import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { BehaviorSubject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { tBookAuxModel } from '../models/tBookAuxModel';


@Injectable({
    providedIn: 'root'
  })
  export class tBookAuxService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;
    readonly pathName = '/tBookAuxModels';

    getAllData(){
      return this.http.get<tBookAuxModel[]>(this.baseurl + this.pathName);
    }

    getAllDataByShop(shopID:number){
      return this.http.get<tBookAuxModel[]>(this.baseurl + this.pathName + '/GetDataByShop/'+shopID);
    }

    getDataByInactiveStatus(shopID: number, inactiveStatus : string){
      return this.http.get<tBookAuxModel[]>(this.baseurl + this.pathName +"/GetDataByStatus/"+ shopID +"/"+ inactiveStatus);
    }
  

    getDataById(bookAuxID: string){
      return this.http.get<tBookAuxModel>(this.baseurl + this.pathName + '/' + bookAuxID);
    }

    addData(data: tBookAuxModel){
      return this.http.post(this.baseurl + this.pathName + '/' + 'Formatted', data);
    }

    deleteData(data: tBookAuxModel){
      return this.http.delete(this.baseurl + this.pathName + '/' + data.bookAuxID);
      // return this.http.delete(this.baseurl + this.pathName + '/' + 'Formatted' + '/' + data.bookAuxID);
    }

    updateData(data: tBookAuxModel){
      console.log();
      // data.lastModifyLoginName = "2";
      return this.http.put(this.baseurl + this.pathName  + '/' + data.bookAuxID, data);
    }



    // private messageSource = new BehaviorSubject('default message');
    // currentMessage = this.messageSource.asObservable();

    // private selected_mediCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediCode = this.selected_mediCode_Source.asObservable();

    // private selected_mediCateCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediCateCode = this.selected_mediCateCode_Source.asObservable();

    // private selected_mediName_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediName = this.selected_mediName_Source.asObservable();

    // private selected_mediNameEng_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediNameEng = this.selected_mediNameEng_Source.asObservable();

    // private selected_mediBarCode_Source = new BehaviorSubject('<未選取>');
    // current_selected_mediBarCode = this.selected_mediBarCode_Source.asObservable();



    // changeMessage(systemMedicineSetting: tVendorModel) {

    //   let mediCodeStr = '';
    //   let mediCateCodeStr = '';
    //   let mediNameStr = '';
    //   let mediNameEngStr = '';
    //   let mediBarCodeStr = '';

    //   if (!isNullOrUndefined(systemMedicineSetting.mediCode)) {
    //     mediCodeStr = systemMedicineSetting.mediCode.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediCateCode)) {
    //     mediCateCodeStr = systemMedicineSetting.mediCateCode.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediName)) {
    //     mediNameStr = systemMedicineSetting.mediName.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediNameEng)) {
    //     mediNameEngStr = systemMedicineSetting.mediNameEng.toString();
    //   }
    //   if (!isNullOrUndefined(systemMedicineSetting.mediBarCode)) {
    //     mediBarCodeStr = systemMedicineSetting.mediBarCode.toString();
    //   }


    //   this.selected_mediCode_Source.next(mediCodeStr);
    //   this.selected_mediCateCode_Source.next(mediCateCodeStr);
    //   this.selected_mediName_Source.next(mediNameStr);
    //   this.selected_mediNameEng_Source.next(mediNameEngStr);
    //   this.selected_mediBarCode_Source.next(mediBarCodeStr);

    //   // this.messageSource.next(message);
    // }
  }